import { gql } from "graphql-tag";

export const GET_CONTACTS = gql`
  query GetContacts(
    $pagination: PaginationInput
    $filter: ContactFilterInput
    $sort: ContactSortInput
  ) {
    contacts(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        firstName
        lastName
        email
        phone
        company
        address
        externalPerson
        emailVerified
        employeeId
        accountId
        type
        userId
        createdAt
        updatedAt
        labelAssignments {
          id
          labelId
          labelableType
          labelableId
          label {
            id
            name
            slug
            color
          }
          createdAt
          updatedAt
        }
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_CONTACT = gql`
  query GetContact($id: ID!) {
    contact(id: $id) {
      id
      firstName
      lastName
      email
      phone
      company
      address
      externalPerson
      emailVerified
      employeeId
      accountId
      type
      userId
      createdAt
      updatedAt
      labelAssignments {
        id
        labelId
        labelableType
        labelableId
        label {
          id
          name
          slug
          color
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const EXPORT_CONTACTS = gql`
  query ExportContacts($filter: ContactFilterInput) {
    exportContacts(filter: $filter) {
      id
      firstName
      lastName
      email
      phone
      company
      address
      externalPerson
      emailVerified
      employeeId
      accountId
      type
      userId
      createdAt
      updatedAt
    }
  }
`;
